import supabase from '../lib/supabaseClient';

export async function verifyMarketingPassword(password) {
  const {data,error}=await supabase.rpc('verify_marketing_password',{pw: password});
  if (error) throw new Error(error.message);
  return data === true;
}